import React from "react";
import { UserOutlined } from "@ant-design/icons";
import { Dropdown, Space, Avatar } from "antd";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Cookie from "react-cookies";

const MenuButton = () => {
  const navigate = useNavigate();

  const logout = () => {
    Cookie.remove("token");
    navigate("/login");
  };

  const items = [
    {
      label: (
        <Link
          onClick={() => {
            logout();
          }}
        >
          Logout
        </Link>
      ),
      key: "1",
    },
  ];

  return (
    <React.Fragment>
      <Dropdown
        menu={{
          items,
        }}
        trigger={["click"]}
      >
        <Link onClick={(e) => e.preventDefault()} className="menu_button">
          <Space>
            Admin
            <Avatar
              style={{
                backgroundColor: "#bb9344",
              }}
              icon={<UserOutlined />}
            />
          </Space>
        </Link>
      </Dropdown>
    </React.Fragment>
  );
};
export default MenuButton;
